import { PkceEnvironmentConfig } from '../types';
import { scopes } from './common';

/**
 * PKCE configuration for TEST environment
 * Applies to: testc.blackrock.com, aztstdmz.blackrock.com
 */
export const tstConfig: PkceEnvironmentConfig = Object.freeze({
  clientId: process.env.VITE_CLIENT_ID_TST || '',
  authorizationUrl: process.env.VITE_AGRAPH_EXTERNAL_DEV_URL + '/api/oauth2/TST/default/v1/authorize',
  tokenUrl: process.env.VITE_AGRAPH_EXTERNAL_DEV_URL + '/api/oauth2/TST/default/v1/token',
  providerConfiguration: {
    idp: process.env.VITE_IDP_PREPROD,
    type: 'okta' as const,
  },
  scope: scopes.join(' '),
  apiBaseUrl: process.env.VITE_AGRAPH_EXTERNAL_DEV_URL || '',
});
